import dayjs, {type Dayjs, type ConfigType, type ManipulateType} from 'dayjs';
import utc from 'dayjs/plugin/utc';
import minMax from 'dayjs/plugin/minMax';
import weekday from 'dayjs/plugin/weekday';
import timezone from 'dayjs/plugin/timezone';
import duration, {type Duration} from 'dayjs/plugin/duration';
import customParse from 'dayjs/plugin/customParseFormat';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import relativeTime from 'dayjs/plugin/relativeTime';

dayjs.extend(utc);
dayjs.extend(minMax);
dayjs.extend(weekday);
dayjs.extend(timezone);
dayjs.extend(duration);
dayjs.extend(customParse);
dayjs.extend(advancedFormat);
dayjs.extend(relativeTime);

export type {Dayjs, ConfigType, ManipulateType, Duration};

export default dayjs;
